import { Reveal } from "@/components/Reveal";
import { TIMELINE_SHORT } from "@/data/content";

const Label = ({ item }) => (
  <span className="block px-1">
    <span className="block font-display text-sm font-bold uppercase tracking-tight text-ink">
      {item.year}
    </span>
    <span className="mt-0.5 block text-[11px] leading-tight text-slate-500">{item.tag}</span>
  </span>
);

export const MilestonesRibbon = () => (
  <div
    id="timeline"
    data-testid="timeline-section"
    className="mt-16 rounded-2xl bg-[#f6f7f9] p-8 md:p-12"
  >
    <Reveal>
      <p className="font-serif text-base italic text-slate-500">Track Record</p>
      <h3 className="mt-2 font-display text-2xl font-bold uppercase tracking-tight text-ink md:text-3xl">
        Company Milestones
      </h3>
    </Reveal>

    <div className="relative mt-10 hidden lg:block">
      <div className="absolute inset-x-0 top-1/2 h-px bg-slate-300" aria-hidden="true" />
      <div className="relative grid grid-cols-11">
        {TIMELINE_SHORT.map((item, i) => (
          <div
            key={item.year}
            data-testid={`timeline-item-${i + 1}`}
            className="flex flex-col items-center"
          >
            <div className="flex h-20 items-end justify-center pb-4 text-center">
              {i % 2 === 0 ? <Label item={item} /> : null}
            </div>
            <span className="h-4 w-4 shrink-0 rounded-full border-2 border-navy bg-white" />
            <div className="flex h-20 items-start justify-center pt-4 text-center">
              {i % 2 === 1 ? <Label item={item} /> : null}
            </div>
          </div>
        ))}
      </div>
    </div>

    <ul className="mt-6 space-y-2 lg:hidden">
      {TIMELINE_SHORT.map((item, i) => (
        <li
          key={item.year}
          data-testid={`timeline-item-mobile-${i + 1}`}
          className="flex items-center gap-3"
        >
          <span
            className="h-3 w-3 shrink-0 rounded-full border-2 border-navy bg-white"
            aria-hidden="true"
          />
          <span className="text-sm">
            <span className="font-display font-semibold uppercase tracking-tight text-ink">
              {item.year}
            </span>
            <span className="text-slate-500">: {item.tag}</span>
          </span>
        </li>
      ))}
    </ul>
  </div>
);
